
import {IResolver, RegistryLookupError} from "./IResolver";


export class Resolver implements IResolver {
    public protocols: {[proto: string]: IResolver} = {
        'void:': {
            async resolve(url: URL, cancel?: AbortSignal): Promise<any> {
                return undefined;
            }
        },
        'data:': {
            async resolve(url: URL, cancel?: AbortSignal): Promise<any> {
                let mime = 'text/plain;charset=US-ASCII';
                let data = url.pathname;
                const comma = data.indexOf(',');
                if (comma !== -1) {
                    mime = data.substring(0, comma);
                    data = data.substring(comma + 1);
                }

                const mimeParts = mime.split(';');

                if (mimeParts[mimeParts.length - 1] === 'base64') {
                    data = atob(data);
                    mimeParts.pop();
                } else {
                    data = decodeURIComponent(data);
                }

                if (mimeParts[0] === 'application/json') {
                    return JSON.parse(data);
                } else if (mimeParts[0] === 'text/plain') {
                    return data;
                } else {
                    throw new Error('unsupported MIME type');
                }
            }
        }
    };

    constructor() {
    }
    async resolve(url: URL, cancel?: AbortSignal) {
        if (url.protocol in this.protocols)
            return this.protocols[url.protocol].resolve(url, cancel);
        else
            throw new RegistryLookupError("protocol", url.protocol);
    }
}
